import { render, staticRenderFns } from "./mobilePage.vue?vue&type=template&id=18889dba&"
import script from "./mobilePage.vue?vue&type=script&lang=js&"
export * from "./mobilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports